module.exports = "<mat-tab-group [disableRipple]=\"true\" (selectedTabChange)=\"onTabClick($event)\" class=\"tabs\">\n  <mat-tab label=\"Sector Index & Profit\">\n    <app-sector-profit></app-sector-profit>\n  </mat-tab>\n\n</mat-tab-group>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/industry-level/industry-level/industry-level.component.html
// module id = ../../../../../src/app/industry-level/industry-level/industry-level.component.html
// module chunks = main